<template>
    <company-profile no-redirect disable-type :company-data="initCompanyProfile()" @save="save" />
</template>

<script lang="ts">
    import {Component, Emit, Vue} from 'vue-facing-decorator'
    import CompanyProfile from '~src/components/account/companyProfile.src'
    import {initCompanyProfile} from '~/utils/types/account/companies/helpers'

    @Component({
        components: {CompanyProfile},
    })
    export class CreateSupplierForm extends Vue {
        @Emit() save(supplier) {
            return supplier
        }

        initCompanyProfile() {
            return {...initCompanyProfile(), type: 'INTERNAL_SUPPLIER'}
        }
    }

    export default CreateSupplierForm
</script>
